import { DOMHelpers } from 'helpers/dom';
import { SubscribableOrNullableValue } from 'knockout';
import { withEffects } from 'mixins/withEffects';

export interface AutofocusManagerConfig {
    enable?: SubscribableOrNullableValue<boolean>
    focus: Action
}

const $document = $(document);
const staticEffects = withEffects();

const actions = ko.observableArray<Action>();
const isDocumentBlurred = ko.observable(false);

const hasActions = actions.any();

function checkDocumentFocus() {
    const hasActiveInput = $(<Element>document.activeElement).is('input, textarea, [contenteditable="true"]');

    isDocumentBlurred(!hasActiveInput);
}

staticEffects.register(hasActions => {
    if (hasActions) {
        $document.on('focusin focusout', checkDocumentFocus);
        checkDocumentFocus();

        return () => {
            $document.off('focusin focusout', checkDocumentFocus);
            isDocumentBlurred(false);
        }
    }
}, [hasActions]);

staticEffects.register((actions, isDocumentBlurred) => {
    const focusFunc = _(actions).last();

    if (focusFunc != undefined && isDocumentBlurred) {
        return DOMHelpers.onNodeEvent(document, 'keydown', e => {
            if (!e.ctrlKey && !e.altKey)
                focusFunc();
        });
    }
}, [actions, isDocumentBlurred]);

export default class AutofocusManager {
    private effects = withEffects();

    constructor(config: AutofocusManagerConfig) {
        const isEnabled = ko.flattenComputed(config.enable, true);
        const focusFunc = config.focus;

        this.effects.register(isEnabled => {
            if (isEnabled) {
                actions.push(focusFunc);

                return () => actions.remove((func:Action) => func == focusFunc);
            }
        }, [isEnabled]);
    }

    dispose() {
        this.effects.dispose();
    }
}